module.exports = __webpack_public_path__ + "static/media/bonos.9328875d.png";